import { render, staticRenderFns } from "./PhotoCard.vue?vue&type=template&id=42037d29&"
import script from "./PhotoCard.vue?vue&type=script&lang=js&"
export * from "./PhotoCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/dan/github/webdev-personal/dan-anan-wedding/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VImg } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VResponsive } from 'vuetify/lib'
installComponents(component, {VBtn,VCard,VCardText,VContainer,VFlex,VImg,VLayout,VResponsive})
